import styled, { css } from 'styled-components';
import { animations, Checkbox } from 'ui-components/src/components/atoms';

export const Actions = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.greyWarm['20']};
  padding: 1rem 0;

  display: flex;
  justify-content: space-between;

  .checkbox > span {
    font-size: 14px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
`;

export const ContinueAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 0.5rem;
`;

export const FieldError = styled.p<{ active?: boolean }>`
  margin: 6px 0 0 0;
  color: ${({ theme }) => theme.colors.secondary.red};
  opacity: ${({ active }) => (active ? 1 : 0)};
  height: ${({ active }) => (active ? '14px' : 0)};
  transition: opacity 0.1s, height 0.1s;
`;

export const StyledCheckbox = styled(Checkbox)<{ hasError?: boolean }>`
  padding-left: 4px;

  ${({ hasError }) =>
    hasError &&
    css`
      animation: ${animations.shake} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97)
        both;
    `}
`;
